import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { useToggle } from 'site-modules/shared/hooks/use-toggle';
import { PhotoflipperVdpModalAsync } from 'site-modules/shared/components/photoflipper-vdp-modal/photoflipper-vdp-modal-async';

export function WithPhotoflipper({ hasPhoto360 = false, onClosed, children, ...props }) {
  const [isModalOpen, toggleModalOpen] = useToggle();
  const currentSlideIndex = useRef(0);

  const setCurrentSlideIndex = useCallback(index => {
    currentSlideIndex.current = index;
  }, []);

  return (
    <>
      {/* eslint-disable-next-line react-hooks/refs -- callbacks passed to event handlers only, not called during render */}
      {children(toggleModalOpen, setCurrentSlideIndex)}
      <PhotoflipperVdpModalAsync
        isOpen={isModalOpen}
        toggle={toggleModalOpen}
        onClosed={onClosed}
        currentSlideIndex={
          // eslint-disable-next-line react-hooks/refs
          hasPhoto360 && currentSlideIndex.current > 0 ? currentSlideIndex.current + 1 : currentSlideIndex.current
        }
        {...props}
      />
    </>
  );
}

WithPhotoflipper.propTypes = {
  hasPhoto360: PropTypes.bool,
  onClosed: PropTypes.func.isRequired,
  children: PropTypes.func.isRequired,
};
